export default __webpack_public_path__ + "static/media/fallon-alexandre.5c2053c5.png";